import { createContext } from "react";
import { View } from "views/View";

export interface ParticipantViewsContextProps {
  views: View[];
  selectedView: View;
  setSelectedViewName: (name: string) => void;
}

export const ParticipantViewsContext = createContext({} as ParticipantViewsContextProps);
